import React from 'react';

class Nothing_here extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <>
                <div className={this.props.wrapperClass}>
                    <div className={this.props.imageAreaClass}>
                        <img src={this.props.imgSrc} alt="" />
                    </div>
                    <p className={this.props.descriptionClass}>{this.props.descriptionText}</p>
                    <button className={this.props.btnClass} data-bs-toggle={this.props.modal} data-bs-target={this.props.modalTarget}>{this.props.btnText}</button>
                </div>
            </>
        );
    }
};

export default Nothing_here;